import * as yup from "yup";

import { VALIDATOR_STRING_REQUIRED } from "../../../constants/validation/validators";

export default yup.object().shape({
  title: VALIDATOR_STRING_REQUIRED,
});
